const STATUS_BADGES = {
  active: { text: '已上线', bg: 'rgba(34,197,94,0.15)', fg: '#16a34a' },
  sandbox: { text: '沙箱', bg: 'rgba(234,179,8,0.15)', fg: '#b45309' },
  draft: { text: '草稿', bg: 'var(--bg-1)', fg: 'var(--fg-3)' },
  in_review: { text: '审核中', bg: 'rgba(59,130,246,0.15)', fg: '#2563eb' },
  superseded: { text: '历史', bg: 'var(--bg-1)', fg: 'var(--fg-4)' },
  suspended: { text: '已暂停', bg: 'rgba(239,68,68,0.15)', fg: '#dc2626' },
};

const UNAVAILABLE_BADGE = { bg: 'rgba(239,68,68,0.15)', fg: '#dc2626' };

/**
 * `major.status=active` means that a serving revision exists. It does not mean
 * traffic can reach it: a deprecated major or a suspended service is offline.
 */
export const getMajorStatusBadge = (major, serviceStatus) => {
  if (major?.deprecated) {
    return {
      ...UNAVAILABLE_BADGE,
      text: major.isDefault ? '服务已下架' : '已弃用',
      title: major.isDefault
        ? '默认大版本已下架，整个服务停止对外流量'
        : `v${major.major} 已弃用，仅该大版本停止对外流量`,
    };
  }

  if (serviceStatus === 'SUSPENDED' && major?.status === 'active') {
    return {
      ...UNAVAILABLE_BADGE,
      text: '服务已暂停',
      title: '该大版本仍保留上线修订，但服务当前暂停，无法对外访问',
    };
  }

  return STATUS_BADGES[major?.status] || {
    text: major?.status,
    bg: 'var(--bg-1)',
    fg: 'var(--fg-3)',
  };
};
